import React from 'react';
import {Container, Paper, Stack, Typography, Button} from "@mui/material";
import {ErrorOutline} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";

const Error = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="sm" sx={{py: 8}}>
            <Paper elevation={0} sx={{p: 4, textAlign: 'center'}}>
                <Stack spacing={2} alignItems="center">
                    <ErrorOutline color="error" sx={{fontSize: 64}}/>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Something went wrong!
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        We can't seem to find the page you're looking for. You can go back to the homepage.
                    </Typography>
                    <Button variant="contained" onClick={() => navigate('/')}>
                        Go to Homepage
                    </Button>
                </Stack>
            </Paper>
        </Container>
    );
}

export default Error;
